import { MediaType } from '@zonofi/common';

export const getMediaType = (contentType: string): MediaType => {
  if (contentType.startsWith('image')) return MediaType.IMAGE;
  if (contentType.startsWith('audio')) return MediaType.AUDIO;
  if (contentType.startsWith('video')) return MediaType.VIDEO;
  return MediaType.DOCUMENT;
};
